import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import Select from "react-select";

const DateTimeGroupsSelector = (props) => {
  const { dateTimeGroups } = props.envStore;
  const { name = "type", setValue } = props;
  const nameKey = "DateTimeGroups";
  // тут можно добавить omit для пропуска определенных значений, но это потом
  const options = () =>
    _.map(dateTimeGroups, (value) => {
      return { value, label: <IntlMessages id={`${nameKey}.${value}`} /> };
    });

  const onChangeHandler = (selectedOptions) => {
    const value = selectedOptions.value;
    // const target = { name, value };
    setValue(value);
  };

  return (
    <Select
      isMulti={false}
      name={name}
      value={
        props.value
          ? {
              value: props.value,
              label: <IntlMessages id={`${nameKey}.${props.value}`} />,
            }
          : null
      }
      width
      options={options()}
      placeholder={<IntlMessages id={`${nameKey}`} />}
      onChange={onChangeHandler}
    />
  );
};

const mapStateToProps = (state) => ({
  envStore: state.api.env,
});

export default connect(mapStateToProps, {})(DateTimeGroupsSelector);
